import script from "./AddActivityModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddActivityModal.vue?vue&type=script&lang=ts&setup=true"

import "./AddActivityModal.vue?vue&type=style&index=0&id=1e14645a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e14645a"]])

export default __exports__